export const ValidationMessages = {
  firstName: [
    { type: 'required', message: 'Required' },
    { type: 'minLength', message: 'Should have at least 1 character' },
  ],
  lastName: [
    { type: 'required', message: 'Last name is required' },
    { type: 'minLength', message: 'Should have at least 1 character' },
  ],
  emailAddress: [
    { type: 'required', message: 'Required' },
    { type: 'email', message: 'Should be valid' },
    { type: 'pattern', message: 'Should not contain spaces' },
  ],
  companyName: [
    { type: 'required', message: 'Company name is required' },
    { type: 'minLength', message: 'Should have at least 1 character' },
  ],
  password: [
    { type: 'minLength', message: 'Should have at least 8 characters' },
    { type: 'maxLength', message: 'Should not have more than 32 characters' },
    {
      type: 'upperCase',
      message: 'Should contain at least one alphabetic upper case character (A-Z)',
    },
    {
      type: 'lowerCase',
      message: 'Should contain at least one alphabetic lower case character (a-z)',
    },
    {
      type: 'digits',
      message: 'Should contain at least one non-alphabetic character (0-9)',
    },
    {
      type: 'specialSymbol',
      message: 'Should contain at least one special character',
    },
    {
      type: 'noWhiteSpace',
      message: 'Should not contain spaces',
    },
  ],
  validator: [
    { type: 'required', message: 'Required' },
    {
      type: 'passwordCompare',
      message: 'Must re-type password to ensure correctness',
    },
  ],
};
